import React from 'react'
import i18n from 'i18next'

import Typography from '../../../UniformComponents/Typography'

const Swot = () => (
    <div>
        <div className="pp-summary-slide-container">
            <div className="pp-summary-slide-header">
                <div className="pp-summary-slide-header-text-container">
                    <Typography type="tiny" color="primary">{i18n.t('s_tab_overview')}</Typography>

                    <Typography color="white">Project specifications - SURVEY NAME</Typography>
                </div>

                <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 30 }} />
            </div>

            <div className="pp-summary-slide-content">
                <div className="pp-summary-slide-content-column">
                    <div>
                        <div className="pp-summary-slide-content-title">
                            <div style={{ backgroundColor: 'green' }} className="pp-summary-slide-orb" />

                            <Typography type="h3">{i18n.t('powerpoint.templates.swot.strengths')}</Typography>
                        </div>
                        <ul style={{ marginLeft: 60 }}>
                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>

                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div className="pp-summary-slide-content-title">
                            <div style={{ backgroundColor: 'green' }} className="pp-summary-slide-orb" />

                            <Typography type="h3">{i18n.t('powerpoint.templates.swot.opportunities')}</Typography>
                        </div>
                        <ul style={{ marginLeft: 60 }}>
                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>

                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pp-summary-slide-content-column">
                    <div>
                        <div className="pp-summary-slide-content-title">
                            <div style={{ backgroundColor: 'orange' }} className="pp-summary-slide-orb" />

                            <Typography type="h3">{i18n.t('powerpoint.templates.swot.weaknesses')}</Typography>
                        </div>
                        <ul style={{ marginLeft: 60 }}>
                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>

                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div className="pp-summary-slide-content-title">
                            <div style={{ backgroundColor: 'red' }} className="pp-summary-slide-orb" />

                            <Typography type="h3">{i18n.t('powerpoint.templates.swot.threats')}</Typography>
                        </div>
                        <ul style={{ marginLeft: 60 }}>
                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>

                            <li>
                                <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default Swot
